<template>
    <div class="coffee-index-home">
        <coffee-category-list v-if="categories.length"
            :categories="categories"
            :plalist-data="playlistData"
            :brewlist-detail="brewlistDetails"
            :buy-now-props="buyNowProps"
            :load-non-categorized-coffees="false"
        />
    </div>

</template>

<script>
    import CoffeeCategoryList from "./coffee-category-list-home";

    export default {
        components: {
            CoffeeCategoryList
        },
        props: {
            coffees: Array,
            buyNowProps: Object,
            playlistData: Object,
            brewlistDetails: Object
        },
        data: function () {
            return {
                categories: []
            }
        },
        methods: {
            groupCoffeesBySamplerCategory() {
                let tmpCategories = [];

                for (let i = 0; i < this.coffees.length; i++) {
                    const coffee = this.coffees[i];
                    const categoryName = coffee.sampler_category || 'others';

                    if (!tmpCategories[categoryName]) {
                        tmpCategories[categoryName] = {
                            coffees: [coffee],
                            heading: this.humanizeHeading(categoryName)
                        }
                    } else {
                        tmpCategories[categoryName].coffees.push(coffee);
                    }
                }

                for (let key in tmpCategories) {

                    // HACK: Make sure the seasonal category comes to the top
                    if (key === 'limited_or_seasonal') {
                        this.categories.unshift(tmpCategories[key]);
                    } else {
                        this.categories.push(tmpCategories[key]);
                    }
                }
            },
            humanizeHeading(heading) {
                let humanizedHeading = heading.replaceAll('_', ' ').toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                return humanizedHeading.replaceAll(' And ', ' and ').replaceAll(' Or ', ' / ').replaceAll(' The ', ' the ')
            }
        },
        mounted() {
            this.groupCoffeesBySamplerCategory();
        }
    }
</script>
